import * as moment from 'moment';

export const getReadableLastSeen = (date: string) => {
  return moment(date).format('DD.MM.YYYY - HH:mm:ss').toString();
};
